// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"122": "21a578a4","354": "9c6094ad","496": "217a0c30","535": "5833aa5d","572": "a76ecf01","61": "4114e666","783": "2ba768bf",}[chunkId] + ".js"
}